/**
 * Normalizes filter options to use new field names while accepting deprecated ones.
 * Use at controller level to support both old and new API contracts.
 *
 * @example
 * // In controller
 * const filters = normalizeFilters({ isActive: true, sort: 'name' });
 * // Result: { active: true, sortBy: 'name', isActive: true, sort: 'name' }
 */
export function normalizeFilters(filters) {
    if (!filters)
        return undefined;
    return {
        ...filters,
        active: filters.active ?? filters.isActive,
        sortBy: filters.sortBy ?? filters.sort,
        sortOrder: filters.sortOrder ?? filters.order,
    };
}
//# sourceMappingURL=filter-options.type.js.map